/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import n from"./BidiEngine.js";const r=new n;function t(n,t=!0){if(!r.hasBidiChar(n))return[n,!1,{...r}];let i;i="rtl"===r.checkContextual(n)?"IDNNN":"ICNNN";const N=t?"VLYSN":"VLYNN";return[r.bidiTransform(n,i,N),!0,{...r}]}export{t as bidiText};
